export const ERROR_PREFIX = 'error' as const;
export const BACKEND_PREFIX = 'back-end' as const;

export const ErrorTranslationKeys = {
  UNIQUE_CONSTRAINT: {
    PREFIX: 'unique-constraint',
    TYPES: {
      PET_NAME_EXISTS: 'pet-name-exists',
      EMAIL_EXISTS: 'email-exists',
      CUSTOM: 'custom',
    },
  },
} as const;

// Helper to create full translation key path
export const createErrorTranslationKey = (
  errorType: typeof ErrorTranslationKeys.UNIQUE_CONSTRAINT.PREFIX,
  subType: (typeof ErrorTranslationKeys.UNIQUE_CONSTRAINT.TYPES)[keyof typeof ErrorTranslationKeys.UNIQUE_CONSTRAINT.TYPES]
): string => {
  return `${ERROR_PREFIX}:${BACKEND_PREFIX}:${errorType}:${subType}`;
};

// Export types for better type safety
export type ErrorType = typeof ErrorTranslationKeys.UNIQUE_CONSTRAINT.PREFIX;
export type ErrorSubType =
  (typeof ErrorTranslationKeys.UNIQUE_CONSTRAINT.TYPES)[keyof typeof ErrorTranslationKeys.UNIQUE_CONSTRAINT.TYPES];
